export default __webpack_public_path__ + "static/media/gallery_05.4f798b34.jpg";